/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HeartIcon24Solid = forwardRef('HeartIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M1.45 9.332C1.45 6.11 3.875 3.5 7.1 3.5c1.9 0 4.146 1.134 4.9 3.392.754-2.258 3-3.392 4.9-3.392 3.225 0 5.65 2.61 5.65 5.832 0 3.704-3.172 6.214-5.625 8.551-.9.857-1.918 1.827-3.058 2.947a2.669 2.669 0 0 1-3.734 0c-1.14-1.12-2.159-2.09-3.058-2.947-2.453-2.337-5.625-4.847-5.625-8.551Z" })));
});
